import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { CurrentUserContext } from "../../../App";
import * as adminApi from "../../../service/adminApi";
import { RedirectCode400 } from "../../RedirectCode400";

function ViewUsermanagement() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [defaultOption, setDefaultOption] = useState("");
  const [data, setData] = useState("");

  useEffect(() => {
    if (location.state?.type === "usermanagement") {
      setTitlePage(location.state?.title || "No Title");
      setTitleValue(location.state?.type || "");
      setDefaultOption("1");
      getUserById();
    } else {
      navigate("/");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location, navigate]);

  const getUserById = async () => {
    let res = await adminApi.getUserById(location.state?.id);
    if (res) {
      if (res["data"]["code"] === 200) {
        setData(res["data"]["user_data"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  // console.log(data);

  const type_user = [
    { name: "ประชาชนทั่วไป", value: "PATIENT" },
    { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
    { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
    { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
    { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
    { name: "ผู้บริหาร", value: "EXECUTIVE" },
    { name: "โรงพยาบาล", value: "HOSPITAL" },
    { name: "ผู้ดูแลระบบ/แอดมิน", value: "ADMIN" },
  ];

  const isProfessional = [
    "MEDICAL_PERSONNEL",
    "LABORATORY_ADMIN",
    "LABORATORY_PERSONNEL",
  ].includes(data?.auth?.role?.[0]);

  const row1 = [
    {
      title: "ประเภทของผู้ใช้งาน",
      detail:
        type_user.find((user) => user.value === data?.auth?.role?.[0])?.name ||
        "ไม่มีข้อมูล",
    },
    ...(isProfessional
      ? [
          {
            title: "ประเภทวิชาชีพ",
            detail: data?.medical_type || "ไม่มีข้อมูล",
          },
          {
            title: "เลขที่ใบประกอบวิชาชีพ",
            detail: data?.license_number || "ไม่มีข้อมูล",
          },
        ]
      : []),
    {
      title: "IAL",
      detail: data?.auth?.user_level || "ไม่มีข้อมูล",
    },
  ];

  const row2 = [
    {
      title: "คำนำหน้า",
      detail: data?.pname || "ไม่มีข้อมูล",
    },
    {
      title: "ชื่อ",
      detail: data?.fname || "ไม่มีข้อมูล",
    },
    {
      title: "นามสกุล",
      detail: data?.lname || "ไม่มีข้อมูล",
    },
    {
      title: "เพศ",
      detail:
        (data?.gender && data?.gender === "male" ? "ชาย" : "หญิง") ||
        (data?.pname && data?.pname === "นาย" ? "ชาย" : "หญิง") ||
        "ไม่มีข้อมูล",
    },
    {
      title: "วัน/เดือน/ปีเกิด",
      detail: data?.birthday || "ไม่มีข้อมูล",
    },
  ];

  const row3 = [
    {
      title: "รหัสไปรษณีย์",
      detail: data?.current_address?.post_code || "ไม่มีข้อมูล",
    },
    {
      title: "เบอร์โทร",
      detail: data?.phone_number || "ไม่มีข้อมูล",
    },
    {
      title: "Email",
      detail: data?.email || "ไม่มีข้อมูล",
    },
  ];

  const row4 = [
    {
      title: "วันที่สร้าง",
      detail: data?.create_date?.date,
    },
    {
      title: "วันที่แก้ไข",
      detail: data?.create_date?.date,
    },
  ];

  return (
    <div>
      <div className="flex flex-row justify-between items-center mb-[10px]">
        <div className="text-3xl md:text-[18px] text-[#747081]">
          {data.fname}
        </div>
        <div className="flex flex-row gap-2">
          <button
            onClick={() =>
              navigate("/admin/usermanagement", {
                state: {
                  type: "usermanagement",
                },
              })
            }
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FFCC99 0% 0% no-repeat padding-box" }}
          >
            <FaArrowLeft style={{ color: "orange" }} />
          </button>
          {/* <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
            onClick={() =>
              navigate(
                "/admin/management/laboratory-inspection-guideline/edit-laboratory",
                {
                  state: {
                    type: "guideline",
                    id: location.state?.id,
                    title: location.state?.title,
                    detail: location.state?.detail,
                    pined: location.state?.pin,
                    active: location.state?.active,
                    publishStartDate: location.state?.publishStartDate,
                    publishEndDate: location.state?.publishEndDate,
                  },
                }
              )
            }
          >
            <FaEdit style={{ color: "green" }} />
          </button> */}
          {/* <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
            // onClick={() => removeGuideline(location.state?.id)}
          >
            <FaTrash style={{ color: "red" }} />
          </button> */}
        </div>
      </div>
      <div className="flex flex-row w-full gap-[10px] md:flex-col">
        <div className="flex flex-col w-[50%] md:w-full gap-[10px]">
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] ">
            {row1.map((item, index) => (
              <div key={index} className="flex flex-row mb-[10px] gap-[10px]">
                <div className="w-[50%] md:w-full font-bold text-[16px] sm:text-[14px]">
                  {item.title}
                </div>
                <div className="w-[50%] md:w-full break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                  {item.title === "คำตอบ" ? (
                    <div dangerouslySetInnerHTML={{ __html: item.detail }} />
                  ) : (
                    item.detail
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] ">
            <div className="text-[18px] mb-[10px]">ข้อมูลส่วนตัว</div>
            {row2.map((item, index) => (
              <div key={index} className="flex flex-row mb-[10px] gap-[10px]">
                <div className="w-[50%] md:w-full font-bold text-[16px] sm:text-[14px]">
                  {item.title}
                </div>
                <div className="w-[50%] md:w-full break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                  {item.title === "คำตอบ" ? (
                    <div dangerouslySetInnerHTML={{ __html: item.detail }} />
                  ) : (
                    item.detail
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col w-[50%] md:w-full">
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] ">
            <div className="text-[18px] mb-[10px]">ที่อยู่ปัจจุบัน</div>
            {row3.map((item, index) => (
              <div key={index} className="flex flex-row mb-[10px] gap-[10px]">
                <div className="w-[50%] md:w-full font-bold text-[16px] sm:text-[14px]">
                  {item.title}
                </div>
                <div className="w-[50%] md:w-full break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                  {item.title === "คำตอบ" ? (
                    <div dangerouslySetInnerHTML={{ __html: item.detail }} />
                  ) : (
                    item.detail
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] ">
            {row4.map((item, index) => (
              <div key={index} className="flex flex-row mb-[10px] gap-[10px]">
                <div className="w-[50%] md:w-full font-bold text-[16px] sm:text-[14px]">
                  {item.title}
                </div>
                <div className="w-[50%] md:w-full break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                  {item.title === "คำตอบ" ? (
                    <div dangerouslySetInnerHTML={{ __html: item.detail }} />
                  ) : (
                    item.detail
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewUsermanagement;
